export function getLocalIP(key) {
    return new Promise(function (resolve, reject) {
        try {
            var RTCPeerConnection = /*window.RTCPeerConnection ||*/ window.webkitRTCPeerConnection || window.mozRTCPeerConnection

            if (!RTCPeerConnection) {
                reject('Your browser does not support this API')
            }
            console.log(`1. getLocalIP [${key}]`)
            var rtc = new RTCPeerConnection({iceServers: []})
            var addrs = {}
            addrs["0.0.0.0"] = false

            function grepSDP(sdp) {
                var hosts = []
                var finalIP = ''
                sdp.split('\r\n').forEach(function (line) {
                    if (~line.indexOf("a=candidate")) {
                        var parts = line.split(' '),
                            addr = parts[4],
                            type = parts[7]
                        if (type === 'host') {
                            finalIP = addr
                        }
                    } else if (~line.indexOf("c=")) {
                        var parts = line.split(' '),
                            addr = parts[2]
                        finalIP = addr
                    }
                })
                return finalIP
            }

            if (1 || window.mozRTCPeerConnection) {
                rtc.createDataChannel('', {reliable: false})
            }

            let hasResolved = false

            setTimeout(() => {
                if (!hasResolved) {
                    reject(`Unknown [${key}]`)
                }
            }, 30 * 1000)

            rtc.onicecandidate = function (evt) {
                console.log(`onicecandidate [${key}]`, evt.candidate)
                if (evt.candidate) {
                    var addr = grepSDP("a=" + evt.candidate.candidate)
                    console.log(`2. getLocalIP => OK [${key}]`)
                    hasResolved = true
                    resolve(addr)
                }
            }
            rtc.createOffer(function (offerDesc) {
                rtc.setLocalDescription(offerDesc)
            }, function (e) {
                console.warn("offer failed", e)
            })
        } catch (e) {
            reject(`3. getLocalIP => [${key}]`, e)
        }
    })
}